/* =============================================
   VP Animate — Staggered fade-up on viewport entry
   Usage: add data-vp-animate to any element.
   Optional: style="--vp-delay: 0.1s" for stagger.
   ============================================= */
(() => {
  if (window.__vpAnimate) return;
  window.__vpAnimate = true;

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('vp-animated');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  document.querySelectorAll('[data-vp-animate]').forEach((el) => io.observe(el));
})();
